import styled from 'styled-components';
import { useState } from 'react';
import { Hero } from '../sections/Hero';
import { ClientGrid } from '../sections/ClientGrid';
import { CTASection } from '../sections/CTASection';
import { getClientsByCategory } from '../../data/clients';
import { PageHead } from '../seo';

const PageWrapper = styled.div`
  padding-top: 73px;
`;

export function Portfolio() {
  const [activeFilter, setActiveFilter] = useState('all');
  const filteredClients = getClientsByCategory(activeFilter);

  return (
    <PageWrapper>
      <PageHead
        title="Client Portfolio"
        description="Selected client work — e-commerce platforms, corporate websites, and custom web applications we've shipped for businesses across industries."
      />
      <Hero
        eyebrow="Portfolio"
        title={
          <>
            Work That{' '}
            <span className="gradient">Drives Results</span>
          </>
        }
        subtitle="From e-commerce platforms to corporate websites, we partner with businesses to deliver solutions that make an impact. Here's a selection of projects we're proud of."
        primaryCTA={{ label: 'Start Your Project', to: '/contact' }}
        secondaryCTA={{ label: 'Our Services', to: '/services' }}
        showStats={false}
      />

      <ClientGrid
        clients={filteredClients}
        showHeader={false}
        showViewAll={false}
        showFilters={true}
        activeFilter={activeFilter}
        onFilterChange={setActiveFilter}
      />

      <CTASection
        title="Let's Build Something Together"
        subtitle="Ready to be our next success story? We'd love to learn about your project."
        primaryCTA={{ label: 'Get in Touch', to: '/contact' }}
        secondaryCTA={{ label: 'View Our Apps', to: '/products' }}
      />
    </PageWrapper>
  );
}
